const gameData = [
  {
    level: 1,
    title: 'Round & Round',
    blocks: 12,
    splits: 2,
    time: 90,
    best: 0,
    noodle: {
      color1: '#00bc9b',
      color2: '#5eaefd',
    },
    path: {
      vert: {
        viewBox: '0 0 1638 2000',
        transform: 'translate(-50 -500)',
        d:
          'M541.42,113.35C1095.13,113.35,1544,562.22,1544,1115.93c0,443-359.1,802.07-802.07,802.07-354.37,0-641.65-287.28-641.65-641.65C100.28,992.85,330.1,763,613.6,763c226.8,0,410.66,183.85,410.66,410.65,0,181.44-147.09,328.53-328.53,328.53-145.15,0-262.82-117.67-262.82-262.82,0-116.12,94.14-210.26,210.26-210.26a168.21,168.21,0,0,1,168.21,168.21A134.57,134.57,0,0,1,676.81,1331.9a107.65,107.65,0,0,1-107.65-107.65,86.12,86.12,0,0,1,86.12-86.12,68.9,68.9,0,0,1,68.9,68.9,55.11,55.11,0,0,1-55.12,55.11A44.09,44.09,0,0,1,625,1218.05a35.28,35.28,0,0,1,35.27-35.28A28.22,28.22,0,0,1,688.46,1211a22.58,22.58,0,0,1-22.57,22.58,18.06,18.06,0,0,1-18.06-18.06,14.44,14.44,0,0,1,14.44-14.45',
      },
      horz: {
        viewBox: '0 0 2001 1638',
        transform: 'translate(0 -200)',
        d:
          'M1915.46 550c0 553.71-448.87 1002.59-1002.58 1002.59-443 0-802.06-359.1-802.06-802.07 0-354.38 287.27-641.65 641.65-641.65 283.5 0 513.32 229.82 513.32 513.32 0 226.8-183.86 410.66-410.66 410.66-181.44 0-328.52-147.09-328.52-328.53 0-145.15 117.67-262.82 262.82-262.82 116.12 0 210.26 94.13 210.26 210.26a168.21 168.21 0 0 1-168.21 168.2 134.55 134.55 0 0 1-134.56-134.61A107.64 107.64 0 0 1 804.57 577.7a86.12 86.12 0 0 1 86.12 86.12 68.89 68.89 0 0 1-68.9 68.89 55.11 55.11 0 0 1-55.12-55.11 44.09 44.09 0 0 1 44.1-44.1A35.28 35.28 0 0 1 846 668.78 28.22 28.22 0 0 1 817.82 697a22.57 22.57 0 0 1-22.57-22.58 18.06 18.06 0 0 1 18.06-18.06 14.45 14.45 0 0 1 14.45 14.45',
      },
    },
  },
  {
    level: 2,
    title: `Make a point`,
    blocks: 12,
    splits: 2,
    time: 60,
    best: 0,
    noodle: {
      color1: '#00bc9b',
      color2: '#5eaefd',
    },
    path: {
      vert: {
        viewBox: '0 0 2001 1638',
        transform: 'translate(-120 -700) scale(1.25 1.25)',
        d:
          'M1114.33,959.75c-11.49,11.34-10,28.72,3.2,39.22,124.25,98.13,257.22,235.16,392.38,413.94,14.33,18.93,11,25.38-7.15,14.51-162.49-96.86-306.53-154-442.46-187.67-15.18-3.72-24.6,7.25-21.13,24.31,35.73,175.67,64.43,375.29,73.12,615.82.84,23.46-4.88,24.76-12.5,2.83-75-216.46-154.64-390.88-241-526.08-8.77-13.83-22-14-29.61-.86a1694.45,1694.45,0,0,1-288.1,371.16c-12,11.73-17,8-11.2-7.91C589,1555.44,619,1409.29,633.56,1268.35c1.41-13.76-9.94-22.58-25.28-19.85-137.55,24.39-290.22,36.84-471.19,23.16-20.21-1.56-23.92-7-8-11.91,150.52-46.48,277.84-111.12,383.81-196,11.32-9,9.91-22.77-2.95-30.39-121.33-71-249.29-153.62-382-249.85-14.07-10.12-10.78-14.2,7-9.47,159.66,42.37,299.88,56.58,433.14,57.61,14.88.14,24.27-11.16,21.07-25.07-33-142.67-57.86-298.73-63.7-483.79-.57-18,5.2-22,12.57-8.53,72.51,133.4,147.16,253.09,230.58,361.24,8.47,11.06,21.61,7.72,29.36-7.62,75.53-151.06,174.21-322.55,298.54-512.31,12.56-19.29,17.45-18.36,11,1.94-65.75,208.28-99.17,389.64-115.18,558.86-1.56,16.45,9.81,25,25.31,19.2,139-52.34,295.1-99.48,482.58-129.66,21-3.4,24.8,4.66,8.3,17.4C1352.49,743.22,1221.91,852.91,1114.33,959.75Z',
      },
      horz: {
        viewBox: '0 0 1638 2000',
        transform: 'translate(-275 -150) scale(1.1 1.1)',
        d:
          'M954,510.9c10,10.13,25.51,7.08,34.67-7,85.5-132.43,197.16-282.7,337.81-448.94,14.86-17.65,20-15.46,11.83,4.68C1265,240,1227.42,397.43,1209.22,544.31c-2,16.37,9.11,25.89,24.67,21.38,160-46.82,339.8-89.06,556.36-116,21.11-2.64,23.79,4.34,5.78,15.15-178.09,106.25-327,203.32-449.59,297.84-12.54,9.6-10.88,24.32,3.52,33.21,141.76,86.62,293.48,207.71,447.65,365.78,15.65,16,13.29,22.11-5,13.61-187.55-86.81-353.52-137.66-510.13-167.45-15.26-2.87-23.92,8.63-19.49,25.62,39.89,152.65,71.85,325.89,81.71,534.06,1.09,23.28-5.62,26-14.59,6C1245.55,1383.9,1155.54,1231,1058,1112.33c-10.35-12.67-26-12.8-35-.81-83.68,113.16-191.62,223.82-326,325.46-14.18,10.76-19.54,6.28-12.15-9.51,65.92-141.79,99.64-268.67,116.16-391,1.84-13.69-9.31-23-24.71-20.81-158.34,22-334.22,33.23-543.25,20.85-20.37-1.23-23-5.74-5.57-9.91,171.76-41.21,317-98.49,437.72-173.74,12.35-7.63,10.81-19.3-3.25-25.76C523.59,764.29,377.6,691.31,226.21,606.27c-15.37-8.55-13.06-12.31,4.88-8.6,184.31,38,345.86,50.6,499.41,51.38,15,.1,23.65-11.12,19.56-25C713.21,500.16,685.59,364.65,679,204.38c-.74-17.89,6-22.71,14.72-10.38C775.5,311,859.81,416,954,510.9Z',
      },
    },
  },
  {
    level: 3,
    title: `Knitting Noodle`,
    blocks: 12,
    splits: 3,
    time: 60,
    best: 0,
    noodle: {
      color1: '#00bc9b',
      color2: '#5eaefd',
    },
    path: {
      vert: {
        viewBox: '0 0 2001 1638',
        transform: 'translate(200 -500)',
        d:
          'M-89.79,356.79H1207.56c254,0,278.18,288,0,288H372.2c-278.17,0-279,289,0,289h835.36c254,0,278.18,287,0,288s-556.35-1-835.36,0-279,289,0,289h835.36c254,0,278.18,289,0,289s-278.17-271-278.17-271-.84-919-.84-1190-277.34-306-277.34,0v1900',
      },
      horz: {
        viewBox: '0 0 1638 2000',
        transform: 'translate(-100 -100)',
        d:
          'M289,1680V382.65c0-253.95,288-278.17,288,0V1218c0,278.17,289,279,289,0V382.65c0-253.95,287-278.17,288,0S1153,939,1154,1218s289,279,289,0V382.65c0-253.95,289-278.17,289,0s-271,278.17-271,278.17-919,.84-1190,.84S-35,939,271,939H2171',
      },
    },
  },

  {
    level: 4,
    title: `Aztec Zone`,
    blocks: 12,
    splits: 3,
    time: 60,
    best: 0,
    noodle: {
      color1: '#00bc9b',
      color2: '#5eaefd',
    },
    path: {
      vert: {
        viewBox: '0 0 2001 1638',
        transform: 'translate(50 -500) scale(1.1 1.1)',
        d:
          'M376.17,1575.82H553a50.15,50.15,0,0,0,50-50V1347.29a48.83,48.83,0,0,0-50-48.9l-126.86,2.8a48.83,48.83,0,0,1-50-48.9v-181a50.71,50.71,0,0,1,50-50.46l354.51-3.25a49.77,49.77,0,0,1,50.14,49.54l.54,185.21A48.78,48.78,0,0,0,881.48,1301l126.87-3.26c27.49-.71,50-23.79,50-51.29V789.38a50.15,50.15,0,0,0-50-50H426.17a50.15,50.15,0,0,1-50-50v-176a50.15,50.15,0,0,1,50-50H553a50.15,50.15,0,0,0,50-50V236.47a50.15,50.15,0,0,1,50-50h355.33a50.15,50.15,0,0,1,50,50V413.34a50.15,50.15,0,0,0,50,50H1236a51.24,51.24,0,0,0,50.9-50l3.2-176.89a51.26,51.26,0,0,1,50.9-50h123.5a50.15,50.15,0,0,1,50,50V689.38a50.15,50.15,0,0,1-50,50H1336a50.15,50.15,0,0,0-50,50v177.7a48.62,48.62,0,0,0,50,48.72l127.7-3.27a48.78,48.78,0,0,1,50.13,48.71l.54,186a50,50,0,0,1-49.85,50H1336a50.15,50.15,0,0,0-50,50v456.24a50.15,50.15,0,0,1-50,50H1108.33a50.15,50.15,0,0,1-50-50V1625.82a50.15,50.15,0,0,0-50-50H881.5c-27.5,0-64.3,17.38-81.77,38.61l-165,200.49c-17.47,21.23-51,26.88-74.44,12.54L191.17,1601.89c-23.47-14.34-42.67-48.57-42.67-76.07V513.34c0-27.5,14.29-67.38,31.76-88.62L376.17,186.47',
      },
      horz: {
        viewBox: '0 0 1638 2000',
        transform: 'translate(-200 -75) scale(0.95 0.95)',
        d:
          'M445.68,363.67V540.5a50.15,50.15,0,0,0,50,50H674.21a48.83,48.83,0,0,0,48.9-50l-2.8-126.86a48.83,48.83,0,0,1,48.9-50h181a50.71,50.71,0,0,1,50.46,50L1004,768.17a49.77,49.77,0,0,1-49.54,50.14l-185.21.54A48.78,48.78,0,0,0,720.5,869l3.26,126.87c.71,27.49,23.79,50,51.29,50h457.07a50.15,50.15,0,0,0,50-50V413.67a50.15,50.15,0,0,1,50-50h176a50.15,50.15,0,0,1,50,50V540.5a50.15,50.15,0,0,0,50,50H1785a50.15,50.15,0,0,1,50,50V995.83a50.15,50.15,0,0,1-50,50H1608.16a50.15,50.15,0,0,0-50,50V1223.5a51.24,51.24,0,0,0,50,50.9l176.89,3.2a51.26,51.26,0,0,1,50,50.9V1452a50.15,50.15,0,0,1-50,50H1332.12a50.15,50.15,0,0,1-50-50V1323.5a50.15,50.15,0,0,0-50-50h-177.7a48.62,48.62,0,0,0-48.72,50l3.27,127.7a48.78,48.78,0,0,1-48.71,50.13l-186,.54a50,50,0,0,1-50-49.85V1323.5a50.15,50.15,0,0,0-50-50H218a50.15,50.15,0,0,1-50-50V1095.83a50.15,50.15,0,0,1,50-50H395.68a50.15,50.15,0,0,0,50-50V869c0-27.5-17.38-64.3-38.61-81.77l-200.49-165c-21.23-17.47-26.88-51-12.54-74.44L419.61,178.67C434,155.2,468.18,136,495.68,136H1508.16c27.5,0,67.38,14.29,88.62,31.76L1835,363.67',
      },
    },
  },
  {
    level: 5,
    title: `Poseidon`,
    blocks: 12,
    splits: 4,
    time: 50,
    best: 0,
    noodle: {
      color1: '#00bc9b',
      color2: '#5eaefd',
    },
    path: {
      vert: {
        viewBox: '0 0 1638 2000',
        transform: 'translate(0 -75) scale(0.9 0.9)',
        d:
          'M2038,503H536c-55,0-100,45-100,100V740c0,55,45,101,100,102.2l73,1.6C664,845,709,891,709,946v131c0,55-45,100.82-100,101.83l-73,1.34c-55,1-100,46.83-100,101.83v133c0,55,45,100,100,100h73c55,0,100,45,100,100v131c0,55-45,100-100,100H262c-55,0-100-45-100-100V1450c0-55,45-100,100-100h893c55,0,100-45,100-100V946c0-55-45-100-100-100h-74c-55,0-100,45-100,100v134c0,55,45,100,100,100h346c55,0,100,45,100,100v466c0,55-45,100-100,100H1081c-55,0-99.86-45-99.7-100l.4-131c.16-55-16.82-141.62-37.75-192.48l-60.9-148C862.12,1223.62,845,1137,845,1082V769a99.58,99.58,0,0,0-100-99.41l-482,2.82A99.82,99.82,0,0,1,162.8,573l-.6-294c-.11-55,44.8-100,99.8-100h74c55,0,145-.17,200-.37l345-1.26c55-.2,128.46,34.48,163.25,77.08L1979,1399',
      },
      horz: {
        viewBox: '0 0 2001 1638',
        transform: 'translate(0 -100)',
        d:
          'M495-359V1143c0,55,45,100,100,100H732c55,0,101-45,102.2-100l1.6-73C837,1015,883,970,938,970h131c55,0,100.82,45,101.83,100l1.34,73c1,55,46.83,100,101.83,100h133c55,0,100-45,100-100v-73c0-55,45-100,100-100h131c55,0,100,45,100,100v347c0,55-45,100-100,100H1442c-55,0-100-45-100-100V524c0-55-45-100-100-100H938c-55,0-100,45-100,100v74c0,55,45,100,100,100h134c55,0,100-45,100-100V252c0-55,45-100,100-100h466c55,0,100,45,100,100V598c0,55-45,99.86-100,99.7l-131-.4c-55-.16-141.62,16.82-192.48,37.75l-148,60.9C1215.62,816.88,1129,834,1074,834H761a99.58,99.58,0,0,0-99.41,100l2.82,482A99.82,99.82,0,0,1,565,1516.2l-294,.6c-55,.11-100-44.8-100-99.8v-74c0-55-.17-145-.37-200l-1.26-345c-.2-55,34.48-128.46,77.08-163.25L1391-300',
      },
    },
  },
  {
    level: 6,
    title: `Convex Castle`,
    blocks: 12,
    splits: 3,
    time: 50,
    best: 0,
    noodle: {
      color1: '#00bc9b',
      color2: '#5eaefd',
    },
    path: {
      vert: {
        viewBox: '0 0 1638 2000',
        transform: 'translate(0 -50) scale(0.9 0.9)',
        d:
          'M1954.24,399.55H1532.67a50.22,50.22,0,0,0-50.06,50l-.26,195.15a50.22,50.22,0,0,1-50.06,50H1294a50.15,50.15,0,0,0-50,50V940a50.15,50.15,0,0,0,50,50h139.21a50.15,50.15,0,0,1,50,50v192.66a50.15,50.15,0,0,1-50,50H1294a50.15,50.15,0,0,0-50,50v191.79a50.6,50.6,0,0,0,50,50.37l139.22,1a50.58,50.58,0,0,1,50,50.36v190a50.15,50.15,0,0,1-50,50H338a50.15,50.15,0,0,1-50-50V1624.45a50.15,50.15,0,0,1,50-50H476.3a50.15,50.15,0,0,0,50-50V1332.66a50.15,50.15,0,0,0-50-50H338a50.15,50.15,0,0,1-50-50V1040.87a50.26,50.26,0,0,1,50-50.09l377.55-.69a50,50,0,0,1,50,49.91v484.45a50.15,50.15,0,0,0,50,50H953.86a50.15,50.15,0,0,0,50-50V750a50.18,50.18,0,0,0-50-50l-813.62-.51a50.19,50.19,0,0,1-50-50V466.26a50.17,50.17,0,0,1,50-50l575.28-.17a50.16,50.16,0,0,0,50-50V165.5a50.37,50.37,0,0,1,50-50.18l139.22-.51a49.93,49.93,0,0,1,50,49.82V349.41a50.15,50.15,0,0,0,50,50H1194a50.15,50.15,0,0,0,50-50V164.63a50.15,50.15,0,0,1,50-50h139.21a49.84,49.84,0,0,0,49.75-50l-.62-120.87',
      },
      horz: {
        viewBox: '0 0 2001 1638',
        transform: 'translate(0 -150)',
        d:
          'M392.79-290V131.57a50.22,50.22,0,0,0,50,50.06l195.15.26a50.22,50.22,0,0,1,50,50.06V370.29a50.15,50.15,0,0,0,50,50h195.3a50.15,50.15,0,0,0,50-50V231.08a50.15,50.15,0,0,1,50-50H1225.9a50.15,50.15,0,0,1,50,50V370.29a50.15,50.15,0,0,0,50,50h191.79a50.6,50.6,0,0,0,50.37-50l1-139.21a50.59,50.59,0,0,1,50.36-50h190a50.15,50.15,0,0,1,50,50V1326.27a50.15,50.15,0,0,1-50,50H1617.69a50.15,50.15,0,0,1-50-50V1187.94a50.15,50.15,0,0,0-50-50H1325.9a50.15,50.15,0,0,0-50,50v138.33a50.15,50.15,0,0,1-50,50H1034.11a50.26,50.26,0,0,1-50.09-50l-.69-377.55a50,50,0,0,1,49.91-50h484.45a50.15,50.15,0,0,0,50-50V710.38a50.15,50.15,0,0,0-50-50H743.2a50.19,50.19,0,0,0-50,50L692.66,1524a50.19,50.19,0,0,1-50,50H459.5a50.17,50.17,0,0,1-50-50l-.17-575.28a50.16,50.16,0,0,0-50-50H158.74a50.37,50.37,0,0,1-50.18-50l-.51-139.21a49.93,49.93,0,0,1,49.82-50H342.65a50.15,50.15,0,0,0,50-50V470.29a50.15,50.15,0,0,0-50-50H157.87a50.15,50.15,0,0,1-50-50V231.08a49.84,49.84,0,0,0-50-49.75L-63,182',
      },
    },
  },
  {
    level: 7,
    title: `Diagonal Dilemma`,
    blocks: 12,
    splits: 3,
    time: 55,
    best: 0,
    noodle: {
      color1: '#00bc9b',
      color2: '#5eaefd',
    },
    path: {
      vert: {
        viewBox: '0 0 1638 2000',
        transform: 'translate(-50 -200)',
        d:
          'M608.84,1480.81c22,0,27.06-12.51,11.25-27.81L361.93,1203.35a41.36,41.36,0,0,1-1.67-57.25l261.5-284.2a36.51,36.51,0,0,1,54.32-.14l259.3,278.82c15,16.11,9.24,29.61-12.76,30l-233.78,4.23c-22,.4-27.53-12.27-12.3-28.14l574-598.18a40.15,40.15,0,0,0-1.14-56.58L991.46,244c-15.87-15.25-28.84-9.72-28.84,12.28V479.64c0,22,13,27.53,28.84,12.28l258-247.94c15.86-15.25,41.8-15.23,57.64,0L1564.2,491.88a39.1,39.1,0,0,1,.43,56l-258,256.43c-15.6,15.51-46.37,28.2-68.37,28.2H1002.62c-22,0-52.87-12.59-68.59-28L361.76,244.24a39.33,39.33,0,0,0-56.09,1.06L73.37,490.6c-15.12,16-15.33,42.3-.44,58.5L306.12,803c14.88,16.2,27.06,11.46,27.06-10.54V559.64c0-22,13-52.47,28.84-67.72L620,244a40.84,40.84,0,0,1,57,.71l887.87,896.75a40.61,40.61,0,0,1,0,56.86L990.75,1778.44c-15.47,15.63-28.13,10.43-28.13-11.57V1520.81c0-22-12.64-27.18-28.08-11.51L676.92,1770.81a39.55,39.55,0,0,1-56.23.09L361.34,1509.22c-15.49-15.63-10.16-28.41,11.84-28.41Z',
      },
      horz: {
        viewBox: '0 0 2001 1638',
        transform: 'translate(-50 -270)',
        d:
          'M513.93,608.32c0,22,12.51,27.06,27.81,11.25l250.47-259a41.33,41.33,0,0,1,57.24-1.67l285.12,262.34a36.51,36.51,0,0,1,.14,54.32L855,935.69c-16.11,15-29.62,9.25-30-12.75l-4.24-234.62c-.4-22,12.26-27.54,28.13-12.3l599.94,575.72a40.14,40.14,0,0,0,56.57-1.14l248.76-258.83c15.24-15.86,9.71-28.84-12.29-28.84H1517.67c-22,0-27.53,13-12.29,28.84l248.76,258.83c15.24,15.86,15.22,41.8-.05,57.64l-248.66,258a39.1,39.1,0,0,1-56,.43L1192.2,1307.81c-15.51-15.6-28.2-46.37-28.2-68.37V1002.93c0-22,12.59-52.86,28-68.58L1753.87,360.4a39.32,39.32,0,0,0-1.06-56.09L1506.71,71.24c-16-15.13-42.3-15.33-58.5-.45l-254.75,234c-16.2,14.88-11.46,27.05,10.54,27.05h233.67c22,0,52.47,13,67.71,28.84l248.76,258.83a40.85,40.85,0,0,1-.71,57l-899.31,890.4a40.6,40.6,0,0,1-56.85,0L215.43,991.07C199.79,975.59,205,962.93,227,962.93H473.93c22,0,27.18-12.63,11.51-28.07L223.08,676.39a39.54,39.54,0,0,1-.09-56.23L485.52,360c15.63-15.48,28.41-10.16,28.41,11.84Z',
      },
    },
  },
  {
    level: 8,
    title: `Tools of the Trade`,
    blocks: 12,
    splits: 3,
    time: 55,
    best: 0,
    noodle: {
      color1: '#00bc9b',
      color2: '#5eaefd',
    },
    path: {
      vert: {
        viewBox: '0 0 1638 2000',
        transform: 'translate(50 -150) scale(0.9 0.9)',
        d:
          'M102.84,42.84V1642.91c0,11,5.62,13,12.49,4.37l208.75-261.13c6.87-8.59,18.21-8.67,25.2-.18l456.91,554.75c7,8.49,18.4,8.46,25.35-.06l213.71-262.25c7-8.53,3.63-15.5-7.37-15.5H839.78c-11,0-14.33,7-7.4,15.52l212.9,262.2c6.93,8.54,21.6,15.5,32.6,15.46l438-1.61c11,0,14.3-7,7.33-15.55L1070.55,1386c-7-8.52-7-22.45,0-31l452.66-554.64c7-8.52,12.65-6.49,12.65,4.51v251.5c0,11-5.71,13-12.68,4.53L1309.54,800.37c-7-8.51-18.48-8.59-25.57-.18l-213.2,253c-7.09,8.41-12.89,6.29-12.89-4.71V804.9c0-11,5.73-26.94,12.73-35.43l213.53-258.89c7-8.49,7-22.38,0-30.88L1070.58,220c-7-8.5-12.7-6.45-12.7,4.55V475.15a20.06,20.06,0,0,1-20,20h-199a20,20,0,0,1-19.94-20l.76-250.63c0-11-5.67-13.06-12.67-4.57L592.65,479.72c-7,8.49-7,22.37,0,30.86L806.18,769.47c7,8.49,12.75,24.43,12.78,35.43l.76,251.5c0,11-5.65,13-12.62,4.53L593.48,800.37c-7-8.51-18.39-8.51-25.36,0L354.5,1060.93c-7,8.51-12.68,6.47-12.68-4.53V804.9c0-11,5.69-13,12.65-4.51L807.13,1355c7,8.53,7,22.46,0,31l-465.29,568.4',
      },
      horz: {
        viewBox: '0 0 2001 1638',
        transform: 'translate(-50 -250) scale(0.95 0.95)',
        d:
          'M2038,102H437.93c-11,0-13,5.62-4.37,12.49L694.69,323.24c8.59,6.87,8.67,18.21.18,25.2L140.12,805.35c-8.49,7-8.46,18.4.06,25.35l262.25,213.71c8.53,6.95,15.5,3.63,15.5-7.37V838.94c0-11-7-14.33-15.52-7.4l-262.2,212.89c-8.54,6.94-15.5,21.61-15.46,32.61l1.61,438c0,11,7,14.3,15.55,7.33l552.92-452.62c8.52-7,22.45-7,31,0l554.64,452.66c8.52,7,6.49,12.65-4.51,12.65h-251.5c-11,0-13-5.71-4.53-12.68l260.56-213.62c8.51-7,8.59-18.48.18-25.57l-253-213.2c-8.41-7.09-6.29-12.89,4.71-12.89h243.62c11,0,26.94,5.73,35.43,12.73l258.89,213.53c8.49,7,22.38,7,30.88,0l259.73-213.58c8.5-7,6.45-12.7-4.55-12.7H1605.69a20.06,20.06,0,0,1-20-20v-199a20,20,0,0,1,20-19.94l250.63.76c11,0,13.06-5.67,4.57-12.67l-259.77-214.4c-8.49-7-22.37-7-30.86,0L1311.37,805.34c-8.49,7-24.43,12.75-35.43,12.78l-251.5.76c-11,0-13-5.65-4.53-12.62l260.56-213.62c8.51-7,8.51-18.39,0-25.36L1019.91,353.66c-8.51-7-6.47-12.68,4.53-12.68h251.5c11,0,13,5.69,4.51,12.65L725.81,806.29c-8.53,7-22.46,7-31,0L126.43,341',
      },
    },
  },
  {
    level: 9,
    title: `Up, Down, Left, Right`,
    blocks: 12,
    splits: 3,
    time: 50,
    best: 0,
    noodle: {
      color1: '#00bc9b',
      color2: '#5eaefd',
    },
    path: {
      vert: {
        viewBox: '0 0 1638 2000',
        transform: 'translate(50 -100) scale(0.9 0.9)',
        d:
          'M1789-66,214.38,1855.65c-34.86,42.54-63.24,32.35-63.08-22.65l.4-132c.16-55,45.3-100,100.3-100H598c55,0,100-45,100-100V1046c0-55,45-100.74,100-101.65l346-5.7c55-.91,100-46.65,100-101.65V367c0-55-45-100.49-100-101.1l-619-6.8A99,99,0,0,0,425,358V495c0,55,45,100.25,100,100.55l891,4.9c55,.3,100,45.55,100,100.55v800c0,55-45,100-100,100h-72c-55,0-100-45-100-100V1370c0-55-45-100-100-100H525c-55,0-100-45-100-100V1037c0-55-45-100.32-100-100.71L0,934',
      },
      horz: {
        viewBox: '0 0 2001 1638',
        transform: 'translate(50 -275) scale(0.95 0.95)',
        d:
          'M2,0,1923.65,1574.62c42.54,34.86,32.35,63.24-22.65,63.08l-132-.4c-55-.16-100-45.3-100-100.3V1191c0-55-45-100-100-100H1114c-55,0-100.74-45-101.65-100l-5.7-346C1005.74,590,960,545,905,545H435c-55,0-100.49,45-101.1,100l-6.8,619A99,99,0,0,0,426,1364H563c55,0,100.25-45,100.55-100l4.9-891C668.75,318,714,273,769,273h800c55,0,100,45,100,100v72c0,55-45,100-100,100H1438c-55,0-100,45-100,100v619c0,55-45,100-100,100H1105c-55,0-100.32,45-100.71,100L1002,1789',
      },
    },
  },
  {
    level: 10,
    title: `Make Your Mind Up`,
    blocks: 12,
    splits: 3,
    time: 50,
    best: 0,
    noodle: {
      color1: '#00bc9b',
      color2: '#5eaefd',
    },
    path: {
      vert: {
        viewBox: '0 0 1638 2000',
        transform: 'translate(50 -100) scale(0.9 0.9)',
        d:
          'M-69.17,522.48,810,1599.53c34.78,42.61,91.66,42.58,126.4-.06L1328.55,1118c34.74-42.64,34.64-112.33-.23-154.87l-391.74-478c-34.86-42.54-101.83-54-148.83-25.39l-348.57,212c-47,28.58-57,86.82-22.22,129.43l393,481.54c34.77,42.61,91.65,42.59,126.39-.06l392.19-481.42c34.74-42.64,34.58-112.29-.35-154.77L1195.49,485.07c-34.93-42.48-92-42.43-126.89.12l-132,161.15c-34.85,42.55-34.83,112.14.06,154.66l395.45,481.88c34.89,42.52,34.9,112.1,0,154.63L938.51,1917.44c-34.88,42.53-92,42.56-126.9.07L157.49,1121.58C122.57,1079.09,94,1089.32,94,1144.32V1577c0,55,45,100,100,100H1551.44c55,0,83-41.68,62.3-92.62l-183.86-451.72c-20.73-50.94-20.57-134.24.37-185.1l184.08-447.25a99.62,99.62,0,0,0-54.62-130L964.45,129.05c-51-20.66-134.65-21.32-186-1.48L54,407.83',
      },
      horz: {
        viewBox: '0 0 2001 1638',
        transform: 'translate(50 -75) scale(0.9 0.9)',
        d:
          'M1479.87-73.13l-1041.4,850c-42.61,34.78-42.58,91.66.06,126.39L900.3,1279.48c42.64,34.73,112.34,34.63,154.87-.23l458.46-375.73c42.54-34.86,54-101.84,25.39-148.83l-202.2-332.53c-28.58-47-86.82-57-129.43-22.22l-461.88,377c-42.61,34.78-42.59,91.66,0,126.39l461.77,376.19c42.65,34.73,112.29,34.57,154.77-.36l151.63-124.68c42.49-34.94,42.43-92-.11-126.89l-151.4-124c-42.55-34.86-112.14-34.83-154.66.06L745.34,1282.89c-42.52,34.89-112.1,34.9-154.63,0L130.37,905.39c-42.53-34.88-42.56-92-.07-126.9l766.59-630C939.38,113.57,929.14,85,874.14,85H461c-55,0-100,45-100,100V1494.35c0,55,41.68,83,92.62,62.3l432.05-175.86c50.94-20.73,134.24-20.57,185.1.37l427.73,176a99.64,99.64,0,0,0,130-54.62L1860,931.43c20.65-51,21.32-134.65,1.48-185.94L1591,46.28',
      },
    },
  },
];

export default gameData;



// WEBPACK FOOTER //
// ./src/API/gameData.js